import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M9 20L4 16L9 12V15H22V17H9V20ZM15 12V9H2V7H15V4L20 8L15 12Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "Transfer"
);
